import React, { memo } from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import { C_PEBBLE, C_METAL, C_EBON, C_SHADOW } from '@bbc/psammead-styles/colours';
import { getSansRegular, getSansBold } from '@bbc/psammead-styles/font-styles';
import { GEL_SPACING_DBL, GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { GEL_BODY_COPY, GEL_MINION } from '@bbc/gel-foundations/typography';
import { detokenise, dictionaryFactory } from '../utilities';
var BORDER_WEIGHT = '0.0625rem';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-4xf90y-0"
})(["", " ", " border:", " solid ", ";border-radius:", ";color:", ";padding:", ";p{margin-top:0;margin-bottom:", ";}a,small{display:block;}a{", " color:", ";text-decoration:none;&:visited{color:", ";}&:hover,&:focus{text-decoration:underline;}}small{margin-top:", ";", "}"], function (_ref) {
  var service = _ref.service;
  return getSansRegular(service);
}, GEL_BODY_COPY, BORDER_WEIGHT, C_PEBBLE, GEL_SPACING, C_SHADOW, GEL_SPACING_DBL, GEL_SPACING, function (_ref2) {
  var service = _ref2.service;
  return getSansBold(service);
}, C_EBON, C_METAL, GEL_SPACING, GEL_MINION);

var Notice = function Notice(_ref3) {
  var provider = _ref3.provider,
      service = _ref3.service,
      text = _ref3.text,
      linkText = _ref3.linkText,
      linkTextSuffixVisuallyHidden = _ref3.linkTextSuffixVisuallyHidden,
      linkHref = _ref3.linkHref,
      warningText = _ref3.warningText;
  var dictionary = dictionaryFactory({
    provider: provider
  });
  var _ref4 = [detokenise(linkText, dictionary), detokenise(linkTextSuffixVisuallyHidden, dictionary)],
      detokenisedLinkText = _ref4[0],
      detokenisedLinkTextSuffix = _ref4[1];
  return /*#__PURE__*/React.createElement(Wrapper, {
    service: service
  }, /*#__PURE__*/React.createElement("p", null, detokenise(text, dictionary)), /*#__PURE__*/React.createElement("a", {
    href: linkHref,
    "aria-label": detokenisedLinkTextSuffix && "".concat(detokenisedLinkText).concat(detokenisedLinkTextSuffix)
  }, detokenisedLinkText), warningText && /*#__PURE__*/React.createElement("small", null, warningText));
};

Notice.defaultProps = {
  linkTextSuffixVisuallyHidden: null,
  warningText: null
};
Notice.propTypes = {
  provider: string.isRequired,
  service: string.isRequired,
  text: string.isRequired,
  linkText: string.isRequired,
  linkTextSuffixVisuallyHidden: string,
  linkHref: string.isRequired,
  warningText: string
};
export default /*#__PURE__*/memo(Notice);